import { api } from "../api";
import { CareTemplate } from "../../model/templates/CareTemplate";
import { parseCareTemplate } from "../../parsers/template/parseCareTemplate";
import { CareTemplateImportExportDto } from "../../generated";

export const importCareTemplate = async (data: string): Promise<CareTemplate> => {
  const result = await api.services.careTemplates.importCareTemplate(JSON.parse(data) as CareTemplateImportExportDto);
  return parseCareTemplate(result.data);
};
